import type { FC, PropsWithChildren } from 'react';
import { useContext } from 'react';
import classNames from 'classnames';

import ConfigContext from 'app/common/ConfigContext';
import DisplayContext from 'app/common/DisplayContext';
import ThemeContext from 'app/common/ThemeContext';
import useIframeHeight from 'app/hooks/useIframeHeight';

import style from './style.module.scss';

const Layout: FC<PropsWithChildren> = ({ children }) => {
  const { full_height } = useContext(ConfigContext);
  const { designVersion } = useContext(ThemeContext);
  const { displayedBlocks, singleBlockDisplay } = useContext(DisplayContext);

  const iframeContainerRef = useIframeHeight();

  return (
    <main
      className={classNames(style.layout, 'override-layout', displayedBlocks, {
        [style.fullWidget]: !singleBlockDisplay,
        [style.fullHeight]: full_height,
        [style.designVersionGrad]: designVersion === 'grad'
      })}
      ref={iframeContainerRef}
    >
      {children}
    </main>
  );
};

Layout.displayName = 'Layout';

export default Layout;
